import Swiper from "swiper";
import "lightgallery.js";
import "lg-video.js";
import "lg-thumbnail.js";

/**
 * @file
 * PDP gallery block module.
 * contains method and function that manages pdp gallery block slider
 * functionality and behavior
 *
 * @author Glory Wiguno <glory@relab.com.au>
 *
 * TODO:
 * - setup for media (video) content for slider
 */

// ---- constants ----
const mainSliderSelector = "pdp-main-slider";
const thumbSliderSelector = "pdp-thumbs-slider";
const activeThumbSliderClass = "pdp-thumbs-slider__slide--active";
const bpTablet = window.matchMedia("(min-width: 768px) and (max-width: 991px)");
const bpDesktop = window.matchMedia("(min-width: 992px)");
const { lightGallery } = window;

// ---- variables ----
let elMainSlider;
let elThumbSlider;
let mainSlider;
let thumbSlider;
let currentActiveSlide;

const init = function() {
  elMainSlider = document.getElementById(mainSliderSelector);
  elThumbSlider = document.getElementById(thumbSliderSelector);

  if (elMainSlider == undefined) return;

  // initialize the slider
  mainSlider = new Swiper("#" + mainSliderSelector, {
    threshold: 50,
    navigation: {
      nextEl: ".pdp-main-slider__nav--next",
      prevEl: ".pdp-main-slider__nav--prev",
      disabledClass: "pdp-main-slider__nav--disabled",
    },
  });

  if (elThumbSlider == undefined) return;
  assignThumbsClickHandler();

  lightGallery(elMainSlider, {
    selector: ".js-slider-lightbox",
    thumbnail: true,
    download: false,
    addClass: "pdp-lightgallery"
  });
  bpTablet.addListener(initThumbsSlider);
  bpDesktop.addListener(initThumbsSlider);
  initThumbsSlider(thumbSliderSelector);

  syncSlideChangesToThumbnail();
  mainSlider.on("slideChange", syncSlideChangesToThumbnail);
  forceResize();
};

/**
 * @name initThumbsSlider
 * @function
 * handles the operations needed to initialize thumbnail slider.
 * thumbnail slider will be reinitialized when the viewport resize changes
 *
 */
const initThumbsSlider = function() {
  const optTablet = {
    slidesPerView: "auto",
    direction: "horizontal",
    spaceBetween: 10,
    threshold: 50,
    navigation: {
      nextEl: ".pdp-thumbs-slider__nav--next",
      prevEl: ".pdp-thumbs-slider__nav--prev",
      disabledClass: "pdp-thumbs-slider__nav--disabled",
    },
  };

  const optDesktop = {
    slidesPerView: "auto",
    direction: "vertical",
    spaceBetween: 10,
    threshold: 50,
    navigation: {
      nextEl: ".pdp-thumbs-slider__nav--next",
      prevEl: ".pdp-thumbs-slider__nav--prev",
      disabledClass: "pdp-thumbs-slider__nav--disabled",
    },
  };

  if (bpTablet.matches) {
    if (thumbSlider != undefined) thumbSlider.destroy(true, true);
    thumbSlider = new Swiper("#" + thumbSliderSelector, optTablet);
  } else if (bpDesktop.matches) {
    if (thumbSlider != undefined) thumbSlider.destroy(true, true);
    thumbSlider = new Swiper("#" + thumbSliderSelector, optDesktop);
  } else {
    if (thumbSlider != null) {
      thumbSlider.destroy(true, true);
      thumbSlider = null;
    }
  }
};

/**
 * @name syncSlideChangesToThumbnail
 * @function
 * add active class to thumbnail slider based on the active slide in main slider
 *
 */
const syncSlideChangesToThumbnail = function() {
  const prevActive = currentActiveSlide;
  currentActiveSlide = mainSlider.realIndex;

  if (thumbSlider != null) {
    if (prevActive != null) thumbSlider.slides[prevActive].classList.remove(activeThumbSliderClass);
    thumbSlider.slides[currentActiveSlide].classList.add(activeThumbSliderClass);
  }
};

/**
 * @name assignThumbsClickHandler
 * @function
 * assigns click handler to thumbnail slider slides
 */
const assignThumbsClickHandler = function() {
  for (let thumbnail of elThumbSlider.querySelectorAll(".pdp-thumbs-slider__slide")) {
    thumbnail.onclick = handleThumbClick;
  }
};

/**
 * @name handleThumbClick
 * @function
 * click handler for thumbnail slider.
 * will trigger main slider to slide to the clicked slide in thumbnail slider
 */
const handleThumbClick = function() {
  mainSlider.slideTo(thumbSlider.clickedIndex);
};

// forces a resize event in browser
const forceResize = () => {
  setTimeout(() => {
    const event = document.createEvent("HTMLEvents");
    event.initEvent("resize", true, false);
    window.dispatchEvent(event);
  }, 450);
};

export default { init };
